import {
  GET_STUDY_LEVELS,
  GET_STUDY_LEVELS_FAIL,
  GET_STUDY_LEVELS_SUCCESS,
  ADD_NEW_STUDY_LEVEL,
  ADD_STUDY_LEVEL_SUCCESS,
  ADD_STUDY_LEVEL_FAIL,
  UPDATE_STUDY_LEVEL,
  UPDATE_STUDY_LEVEL_SUCCESS,
  UPDATE_STUDY_LEVEL_FAIL,
  DELETE_STUDY_LEVEL,
  DELETE_STUDY_LEVEL_SUCCESS,
  DELETE_STUDY_LEVEL_FAIL,
  
} from "./actionTypes";

export const getStudyLevels = () => ({
  type: GET_STUDY_LEVELS,
})

export const getStudyLevelsSuccess = (studyLevels) => ({
  type: GET_STUDY_LEVELS_SUCCESS,
  payload: studyLevels,
})

export const getStudyLevelsFail = error => ({
  type: GET_STUDY_LEVELS_FAIL,
  payload: error,
})

export const addNewStudyLevel = (studyLevel) => ({
  type: ADD_NEW_STUDY_LEVEL,
  payload: studyLevel,
})

export const addStudyLevelSuccess = (studyLevel) => ({
  type: ADD_STUDY_LEVEL_SUCCESS,
  payload: studyLevel,
})

export const addStudyLevelFail = error => ({
  type: ADD_STUDY_LEVEL_FAIL,
  payload: error,
})

export const updateStudyLevel = (studyLevel) => ({
  type: UPDATE_STUDY_LEVEL,
  payload: studyLevel,
})

export const updateStudyLevelSuccess = (studyLevel) => ({
  type: UPDATE_STUDY_LEVEL_SUCCESS,
  payload: studyLevel,
})

export const updateStudyLevelFail = error => ({
  type: UPDATE_STUDY_LEVEL_FAIL,
  payload: error,
})

export const deleteStudyLevel = (studyLevel) => ({
  type: DELETE_STUDY_LEVEL,
  payload: studyLevel,
})

export const deleteStudyLevelSuccess = (studyLevel) => ({
  type: DELETE_STUDY_LEVEL_SUCCESS,
  payload: studyLevel,
})

export const deleteStudyLevelFail = error => ({
  type: DELETE_STUDY_LEVEL_FAIL,
  payload: error,
})

export const resetLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});
